import { axios } from './config';

// 重大危险源列表
export function hazardInstallationsList(params) {
  return axios.get('/dsMajorHazards/list_all', params, false)
}

// 重大危险源新增
export function hazardInstallationsAdd(params) {
  return axios.post('/dsMajorHazards/save', params, false)
}

// 重大危险源编辑
export function hazardInstallationsEdit(params) {
  return axios.post('/dsMajorHazards/update', params, false)
}

// 重大危险源详情
export function hazardInstallationsDetail(params) {
  return axios.get(`/dsMajorHazards/info/${params}`, true)
}

// 重大危险源删除
export function hazardInstallationsDelete(params) {
  return axios.post(`/dsMajorHazards/delete/${params}`)
}

// 生产装置列表
export function productionUnitList(params) {
  return axios.get('/dsProcessUnits/list_all', params, true)
}

// 生产装置新增
export function productionUnitAdd(params) {
  return axios.post('/dsProcessUnits/save', params, false)
}

// 生产装置编辑
export function productionUnitEdit(params) {
  return axios.post('/dsProcessUnits/update', params, false)
}

// 生产装置详情
export function productionUnitDetail(params) {
  return axios.get(`/dsProcessUnits/info/${params}`, true)
}

// 生产装置删除
export function productionUnitDelete(params) {
  return axios.post(`/dsProcessUnits/delete/${params}`)
}

// 库房区域 - 列表
export function warehouseAreaList(params) {
  return axios.get('/dsWarehouseArea/list_all', params, true)
}

// 库房区域 - 新增
export function warehouseAreaAdd(params) {
  return axios.post('/dsWarehouseArea/save', params, false)
}

// 库房区域 - 编辑
export function warehouseAreaEdit(params) {
  return axios.post('/dsWarehouseArea/update', params, false)
}

// 库房区域 - 详情
export function warehouseAreaDetail(params) {
  return axios.get(`/dsWarehouseArea/info/${params}`, true)
}

// 库房区域删除
export function warehouseAreaDelete(params) {
  return axios.post(`/dsWarehouseArea/delete/${params}`, true)
}

// 库房信息 - 列表
export function storehouseAreaList(params) {
  return axios.get('/dsWarehouse/list_all', params, true)
}

// 库房信息 - 新增
export function storehouseAreaAdd(params) {
  return axios.post('/dsWarehouse/save', params, false)
}

// 库房信息 - 编辑
export function storehouseAreaEdit(params) {
  return axios.post('/dsWarehouse/update', params, false)
}

// 库房信息 - 详情
export function storehouseAreaDetail(params) {
  return axios.get(`/dsWarehouse/info/${params}`, true)
}

// 库房信息 - 删除
export function storehouseAreaDelete(params) {
  return axios.post(`/dsWarehouse/${params}`)
}

// 储罐区域 - 列表
export function storageTankList(params) {
  return axios.get('/dsStorageTankArea/list_all', params, true)
}

// 储罐区域 - 新增
export function storageTankAdd(params) {
  return axios.post('/dsStorageTankArea/save', params, false)
}

// 储罐区域 - 编辑
export function storageTankEdit(params) {
  return axios.post('/dsStorageTankArea/update', params, false)
}

// 储罐区域
export function storageTankDetail(params) {
  return axios.get(`/dsStorageTankArea/info/${params}`, true)
}

// 储罐区域 - 删除
export function storageTankDelete(params) {
  return axios.post(`/dsStorageTankArea/delete/${params}`)
}

// 储罐 - 列表
export function tankList(params) {
  return axios.get('/dsStorageTank/list_all', params, true)
}

// 储罐 - 新增
export function tankAdd(params) {
  return axios.post('/dsStorageTank/save', params, false)
}

// 储罐 - 编辑
export function tankEdit(params) {
  return axios.post('/dsStorageTank/update', params, false)
}

// 储罐 - 详情
export function tankDetail(params) {
  return axios.get(`/dsStorageTank/info/${params}`, true)
}

// 储罐 - 删除
export function tankDelete(params) {
  return axios.post(`/dsStorageTank/delete/${params}`)
}

// 联锁 - 列表
export function interlockingList(params) {
  return axios.get('/dsChainManagement/list_all', params, true)
}

// 联锁 - 新增
export function interlockingAdd(params) {
  return axios.post('/dsChainManagement/save', params, false)
}

// 联锁 - 编辑
export function interlockingEdit(params) {
  return axios.post('/dsChainManagement/update', params, false)
}

// 联锁 - 详情
export function interlockingInfo(params) {
  return axios.get(`/dsChainManagement/info/${params}`, true)
}

// 联锁 - 删除
export function interlockingDelete(params) {
  return axios.get(`/dsChainManagement/delete/${params}`)
}

// 联锁 - 连锁
export function locking(params) {
  return axios.post('/dsChainManagement/chain', params, false)
}

// 联锁 - 检查
export function check(params) {
  return axios.post('/dsChainManagement/recheck', params, false)
}

// 联锁 - 摘除
export function extirpate(params) {
  return axios.post('/dsChainManagement/take_down', params, false)
}
